import EventIndex from '@/views/auth/event/Index.vue';
import EventCompactIndex from '@/views/auth/event/Compact.vue';
import EventCompactEdit from '@/views/auth/event/Compact/_id.vue';
import EventEdit from '@/views/auth/event/_id.vue';
import EventExpressEdit from '@/views/auth/event/express/_id.vue';
import EventClass from '@/views/auth/event/_id/event-class.vue';
import InfoCategories from '@/views/auth/event/_id/info-categories.vue';
import AdditionalInfo from '@/views/auth/event/_id/additional-info.vue';
import Description from '@/views/auth/event/_id/description.vue';
import Schedule from '@/views/auth/event/_id/schedule.vue';
import Titelbild from '@/views/auth/event/_id/titelbild.vue';
import SubEvents from '@/views/auth/event/_id/SubEvents.vue';
import Submit from '@/views/auth/event/_id/submit.vue';
import Publish from '@/views/auth/event/_id/publish.vue';
import Metadata from '@/views/auth/event/_id/metadata.vue';
import ExpressInfo from '@/views/auth/event/express/_id/info.vue';
import ExpressAdditionalInfo from '@/views/auth/event/express/_id/additional-info.vue';
import ExpressSchedule from '@/views/auth/event/express/_id/schedule.vue';
import ExpressTitelbild from '@/views/auth/event/express/_id/titelbild_simple.vue';
import ExpressSubmit from '@/views/auth/event/express/_id/submit.vue';
import ExpressPublish from '@/views/auth/event/express/_id/publish.vue';
import { getI18nInstance } from '@/i18n';
import Gage from '@/views/auth/event/_id/EventGage.vue';

export default [
    {
        path: '/event',
        name: 'event',
        component: EventIndex,
        meta: {
            requiresAuth: true,
            title: () => getI18nInstance().t('agenda'),
        },
    },
    {
        path: '/event/:id(\\d+|new)',
        component: EventEdit,
        meta: {
            requiresAuth: true,
            title: () => getI18nInstance().t('agenda'),
        },
        children: [
            {
                path: '/',
                name: 'event-edit',
                component: EventClass,
            },
            {
                path: 'categories',
                name: 'event-info-categories',
                component: InfoCategories,
            },
            {
                path: 'info',
                name: 'event-additional-info',
                component: AdditionalInfo,
            },
            {
                path: 'description',
                name: 'event-description',
                component: Description,
            },
            {
                path: 'schedule',
                name: 'event-schedule',
                component: Schedule,
            },
            {
                path: 'images',
                name: 'event-edit-image',
                component: Titelbild,
            },
            {
                path: 'sub-events',
                name: 'event-sub-events',
                component: SubEvents,
            },
            {
                path: 'submit',
                name: 'event-submit',
                component: Submit,
            },
            {
                path: 'publish',
                name: 'event-publish',
                component: Publish,
            },
            {
                path: 'metadata',
                name: 'event-metadata',
                component: Metadata,
            },
            {
                path: 'gage',
                name: 'event-gage',
                component: Gage,
            },
        ],
    },
    {
        path: '/event/express/:id(\\d+|new)',
        component: EventExpressEdit,
        meta: {
            requiresAuth: true,
            title: () => getI18nInstance().t('agenda'),
        },
        children: [
            {
                path: '/',
                name: 'event-express-edit',
                component: ExpressInfo,
            },
            {
                path: 'info',
                name: 'event-express-info',
                component: ExpressAdditionalInfo,
            },
            {
                path: 'schedule',
                name: 'event-express-schedule',
                component: ExpressSchedule,
            },
            {
                path: 'images',
                name: 'event-express-edit-image',
                component: ExpressTitelbild,
            },
            {
                path: 'submit',
                name: 'event-express-submit',
                component: ExpressSubmit,
            },
            {
                path: 'publish',
                name: 'event-express-publish',
                component: ExpressPublish,
            },
            {
                path: 'gage',
                name: 'event-express-gage',
                component: Gage,
            },
        ],
    },
    {
        path: '/event/compact/',
        component: EventCompactIndex,
        name: 'event-compact',
        meta: {
            requiresAuth: true,
            title: () => getI18nInstance().t('agenda'),
        },
        children: [
            {
                path: ':id(\\d+)',
                name: 'event-compact-edit',
                component: EventCompactEdit,
            },
        ],
    },
];
